export default __webpack_public_path__ + "static/optosweden-rgb-77be9ab36e7e2411a912cbf4a8ec686f.svg";